import {EntityBase} from "../../../shared/entity/EntityBase";

const SHOPPING_ROAD_MANAGER_FIELDS = {
    seq: { type: parseInt, defaultValue: 0 },
    restartDia: { type: parseInt, defaultValue: 0 },
    refreshDia: { type: parseInt, defaultValue: 0 },
    refreshFree: { type: parseInt, defaultValue: 0 },
    eventPass: { type: parseInt, defaultValue: 0 },
    easyRewards: { type: Array, defaultValue: [] },
    normalRewards: { type: Array, defaultValue: [] },
    hardRewards: { type: Array, defaultValue: [] },
    resourceIdx: { type: parseInt, defaultValue: 0 },
    memo: { defaultValue: '' },
}

export class ShoppingRoadManagerEntity extends EntityBase{
    constructor(data = {}) {
        super(data, SHOPPING_ROAD_MANAGER_FIELDS);

        this.errors = [
        ];
    }
}